import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

import {
  IAuthRequest,
  IAuthResponse,
  IAuthResponseBack,
  IRefreshRequest,
  IRegisterRequest,
} from '../types'

const baseQuery = fetchBaseQuery({
  baseUrl:
    import.meta.env.VITE_USER_NODE_ENV === 'development'
      ? `${import.meta.env.VITE_API_URL}/auth`
      : '/api/v1/auth',
})

const transformToken = (data: IAuthResponse | IAuthResponseBack) => {
  const { access_token, refresh_token } = data as IAuthResponseBack

  if (access_token)
    return {
      accessToken: access_token,
      refreshToken: refresh_token,
    }

  const { accessToken, refreshToken } = data as IAuthResponse

  if (accessToken)
    return {
      accessToken: accessToken,
      refreshToken: refreshToken,
    }

  return {
    accessToken: '',
    refreshToken: '',
  }
}

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery,
  tagTypes: ['token'],
  endpoints: build => ({
    login: build.mutation<IAuthResponse, IAuthRequest>({
      query: body => ({
        url: '/token',
        // url: '/login',
        method: 'POST',
        body,
      }),
      transformResponse: transformToken,
    }),

    register: build.mutation<IAuthResponse, IRegisterRequest>({
      query: body => ({
        url: '/register',
        method: 'POST',
        body,
      }),
      transformResponse: transformToken,
    }),

    refreshTokens: build.mutation<IAuthResponse, IRefreshRequest>({
      query: body => ({
        url: '/refresh',
        method: 'POST',
        body,
      }),
      transformResponse: transformToken,
    }),
  }),
})

export const {
  useLoginMutation,
  useRegisterMutation,
  useRefreshTokensMutation,
} = authApi
